const lcd = "https://terra-classic-lcd.publicnode.com";

export async function checkOwnedNFTs(walletAddress, contractAddress) {
  const query = {
    tokens: {
      owner: walletAddress,
      limit: 30 // adjust as needed
    }
  };
  console.log(query);

  const base64Query = btoa(JSON.stringify(query));

  const url = `${lcd}/cosmwasm/wasm/v1/contract/${contractAddress}/smart/${base64Query}`;
  
  console.log(url);

  try {
    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    const json = await res.json();

    if (json.data && json.data.tokens && json.data.tokens.length > 0) {
      return json.data.tokens;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
}

